import global from "./global";
import card from "./Components/card";
import button from "./Components/button";
import drawer from "./Components/drawer";
import menu from "./Components/menu";
import message from "./Components/message";
import inputtext from "./Components/inputtext";
import select from "./Components/select";
import autocomplete from "./Components/autocomplete";
import textarea from "./Components/textarea";
import avatar from "./Components/avatar";
import datatable from "./Components/datatable";
import paginator from "./Components/paginator";
import tooltip from "./Components/tooltip";
import confirmpopup from "./Components/confirmpopup";
import checkbox from "./Components/checkbox";
import fileupload from "./Components/fileupload";
import popover from "./Components/popover";
import buttongroup from "./Components/buttongroup";
import slider from "./Components/slider";
import datepicker from "./Components/datepicker";
import progressspinner from "./Components/progressspinner";
import password from "./Components/password";
import progressbar from "./Components/progressbar";
import dialog from "./Components/dialog";
import inputnumber from "./Components/inputnumber";
import toast from "./Components/toast";
import toggleswitch from "./Components/toggleswitch";
import panel from "./Components/panel";
import chip from "./Components/chip";
import radiobutton from "./Components/radiobutton";
import confirmdialog from "./Components/confirmdialog";
import overlaybadge from "./Components/overlaybadge";
import badge from "./Components/badge";
import splitbutton from "./Components/splitbutton";
import multiselect from "./Components/multiselect";
import iconfield from "./Components/iconfield";
import tag from "./Components/tag";
import tab from "./Components/tab";
import tablist from "./Components/tablist";
import tabpanels from "./Components/tabpanels";
import tabpanel from "./Components/tabpanel";
import tabs from "./Components/tabs";
import carousel from "./Components/carousel";
import selectbutton from "./Components/selectbutton";
import togglebutton from "./Components/togglebutton";
import galleria from "./Components/galleria";
import accordion from "./Components/accordion";
import accordionpanel from "./Components/accordionpanel";
import accordionheader from "./Components/accordionheader";
import accordioncontent from "./Components/accordioncontent";
import speeddial from "./Components/speeddial";
import editor from "./Components/editor";
import skeleton from "./Components/skeleton";

const theme = {
    global,
    directives: {
        tooltip,
    },
    accordion,
    accordionpanel,
    accordionheader,
    accordioncontent,
    avatar,
    badge,
    button,
    buttongroup,
    card,
    confirmpopup,
    confirmdialog,
    datatable,
    drawer,
    dialog,
    galleria,
    menu,
    message,
    overlaybadge,
    paginator,
    panel,
    popover,
    progressspinner,
    progressbar,
    skeleton,
    splitbutton,
    speeddial,
    tag,
    tab,
    tablist,
    tabpanels,
    tabpanel,
    tabs,
    toast,
    carousel,
    // Forms
    autocomplete,
    checkbox,
    chip,
    datepicker,
    fileupload,
    selectbutton,
    iconfield,
    inputnumber,
    inputtext,
    multiselect,
    radiobutton,
    select,
    password,
    dropdown: select,
    slider,
    textarea,
    toggleswitch,
    togglebutton,
    editor,
};

export default theme;
